import { type CreateOptions } from '@anycable/core'
import { type AlmanacCableConsumer } from './types'

import { DebugActionCableConsumer } from './DebugActionCableConsumer'

export function createDebugConsumer(
  url: string,
  opts: Partial<CreateOptions>,
  fallbackUrl: string,
): AlmanacCableConsumer {
  return new DebugActionCableConsumer(url, opts, fallbackUrl)
}
